const Config: any = {
  BaseUrlDev: process.env.REACT_APP_API_URL_DEV,
  BaseUrlProd: process.env.REACT_APP_API_URL_PROD,
  BaseUrlPickupStudentDev: process.env.REACT_APP_PICKUP_STUDENT_DEV,
  BaseUrlPickupStudentProd: process.env.REACT_APP_PICKUP_STUDENT_PROD,
  BaseUrlAttendanceProDev: process.env.REACT_APP_ATTENDANCE_PRO_DEV,
  BaseUrlAttendanceProProd: process.env.REACT_APP_ATTENDANCE_PRO_PROD,
};
let baseUrl = "";
export const check = () => {
  if (process.env.NODE_ENV == "production") {
    baseUrl = Config.BaseUrlProd;

    // remove consoles in production
    console.log = () => {};
    console.debug = () => {};
    console.info = () => {};
    console.warn = () => {};
  } else {
    baseUrl = Config.BaseUrlDev;
  }
  return baseUrl;
};
export default Config;
